const COMPANY_JOBS_ENHANCED_ATTRIBUTE = 'data-fj-company-jobs-enhanced';
const COMPANY_APPLICATION_DETAILS_ENHANCED_ATTRIBUTE = 'data-fj-company-application-details-enhanced';

function normalized(value: string | undefined): string {
    return String(value ?? '').trim().toLowerCase();
}

export function initializeCompanyWorkspace(root: ParentNode = document): void {
    root.querySelectorAll<HTMLElement>('[data-fj-company-jobs]').forEach((surface) => {
        if (surface.hasAttribute(COMPANY_JOBS_ENHANCED_ATTRIBUTE)) return;

        const search = surface.querySelector<HTMLInputElement>('[data-fj-company-job-search]');
        const status = surface.querySelector<HTMLSelectElement>('[data-fj-company-job-status]');
        const resultCount = surface.querySelector<HTMLElement>('[data-fj-company-job-result-count]');
        const emptyState = surface.querySelector<HTMLElement>('[data-fj-company-job-empty]');
        const rows = Array.from(surface.querySelectorAll<HTMLElement>('[data-fj-company-job-row]'));
        if (!search || !status || !resultCount || !emptyState) return;

        surface.setAttribute(COMPANY_JOBS_ENHANCED_ATTRIBUTE, 'true');

        const filterRows = (): void => {
            const query = normalized(search.value);
            const selectedStatus = normalized(status.value);
            let visibleCount = 0;

            rows.forEach((row) => {
                const matchesQuery = !query || normalized(row.dataset.jobSearch).includes(query);
                const matchesStatus = selectedStatus === 'all' || normalized(row.dataset.jobStatus) === selectedStatus;
                const visible = matchesQuery && matchesStatus;
                row.hidden = !visible;
                row.setAttribute('aria-hidden', String(!visible));
                if (visible) visibleCount += 1;
            });

            resultCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'job' : 'jobs'}`;
            // The server-rendered empty table row owns the no-jobs state. The
            // filter state is only shown when there are rows to filter.
            emptyState.hidden = rows.length === 0 || visibleCount !== 0;
        };

        search.addEventListener('input', filterRows);
        status.addEventListener('change', filterRows);
        filterRows();
    });

    initializeCompanyApplicationDetails(root);
}

/**
 * Keep the server-rendered portfolio disclosures keyboard-readable. Native
 * details elements own expansion and remain usable without JavaScript; this
 * only mirrors their state onto the summary for assistive technology.
 */
export function initializeCompanyApplicationDetails(root: ParentNode = document): void {
    root.querySelectorAll<HTMLElement>('[data-fj-company-application-detail]').forEach((surface) => {
        if (surface.hasAttribute(COMPANY_APPLICATION_DETAILS_ENHANCED_ATTRIBUTE)) return;
        const details = Array.from(surface.querySelectorAll<HTMLDetailsElement>('details[data-fj-portfolio-resume], details[data-fj-portfolio-item]'));
        if (details.length === 0) return;

        surface.setAttribute(COMPANY_APPLICATION_DETAILS_ENHANCED_ATTRIBUTE, 'true');
        details.forEach((detail) => {
            const summary = detail.querySelector<HTMLElement>('summary');
            if (!summary) return;
            const syncExpandedState = (): void => {
                summary.setAttribute('aria-expanded', String(detail.open));
            };
            detail.addEventListener('toggle', syncExpandedState);
            syncExpandedState();
        });
    });
}
